import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {MatchWidgetController} from "../match-widget.controller";

export class MatchWidgetProps extends BaseModuleProps {
  controller: MatchWidgetController;
  onSeeAllClick: Function;
}
